<div class="prime-card" @fadeSlideInUp>
    <img class="prime-card-glow-top" src="assets/svg/icons/glow.svg" />
    <main class="prime-card-body">
        <web-brand-logo *ngIf="isBrandLogoVisible" [brandLogoWhite]="true"></web-brand-logo>
        <div class="body-content-top">
            <span class="icon card-icon-center" [svgIcon]="icon"></span>
            <h3 class="card-title-gradient-center text-pre-line">{{ title }}</h3>
        </div>
        <div class="body-content-bottom mt-auto">
            <h3 *ngIf="description && !isInnerHtml" class="bottom-assisttext-60 text-center">
                {{ description }}
            </h3>
            <p *ngIf="description && isInnerHtml" [innerHTML]="description"></p>
            <div *ngIf="retryAfter">
                <div class="counter" *ngIf="timeLeft">
                    <!-- <p class="counter-title">{{ retryAfterTitle }}</p> -->
                    <p class="counter-title">Try again in...</p>
                    <div class="counter-content">
                        <div class="counter-content-item" *ngIf="counter.days !== 0">
                            <h3 class="counter-content-item-count">{{ counter.days | number: "2.0" }}</h3>
                            <span class="counter-content-item-label">Days</span>
                        </div>
                        <span class="dot" *ngIf="counter.days !== 0">:</span>
                        <div class="counter-content-item" *ngIf="counter.hours !== 0">
                            <h3 class="counter-content-item-count">{{ counter.hours | number: "2.0" }}</h3>
                            <span class="counter-content-item-label">hours </span>
                        </div>
                        <span class="dot" *ngIf="counter.hours !== 0">:</span>
                        <div class="counter-content-item">
                            <h3 class="counter-content-item-count">{{ counter.minutes | number: "2.0" }}</h3>
                            <span class="counter-content-item-label">minutes </span>
                        </div>
                        <span class="dot">:</span>
                        <div class="counter-content-item">
                            <h3 class="counter-content-item-count">{{ counter.seconds | number: "2.0" }}</h3>
                            <span class="counter-content-item-label">seconds </span>
                        </div>
                    </div>
                </div>

                <!-- <button type="button" class="primary-fill-btn mx-auto" (click)="retryAfterContinue()">
                    {{ retryAfterButtonName }} dsfdsfdsf
                </button> -->
            </div>
        </div>
    </main>

    <div *ngIf="leftButtonRoute || rightButtonRoute || redirectRoute" class="prime-card-footer">
        <div class="prime-card-footer-left">
            <button *ngIf="leftButtonRoute" type="button" class="primary-outline-btn" (click)="back()">
                {{ leftButtonName }}
            </button>
            <button *ngIf="redirect && redirectRoute" type="button" class="text-btn">
                Redirecting in {{ redirectCountdown }}...
            </button>
        </div>
        <div *ngIf="rightButtonRoute" class="prime-card-footer-right">
            <button type="button" class="primary-fill-btn" [disabled]="timeLeft > 0" (click)="continue()">
                {{ rightButtonName }}
                <img *ngIf="rightButtonIcon" class="icon-primary" [src]="rightButtonIcon" alt="arrow-right-up" />
            </button>
        </div>
    </div>
</div>
